import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
/*
 * Highlight any value that matches match. This returns
 * safe html that must be bound to an innerHTML attribute
 * of an element.
 * Usage:
 *   value | highlight:match
 */
@Pipe({
  standalone: false, name: 'highlight', pure: true })
export class HighlightPipe implements PipeTransform {
  constructor(private sanitized: DomSanitizer) {}
  transform(value: string, match: string): any {
    if (typeof value !== 'string') {
      return value;
    }
    if (typeof match !== 'string' || !match) {
      return value;
    }
    const escaped = match.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const highReg = new RegExp(escaped, 'ig');
    const highlighted = value.replace(highReg, '<span style="background-color: yellow">$&</span>');
    return this.sanitized.bypassSecurityTrustHtml(highlighted);
  }
}
